// Marketing/legal destinations reused verbatim across several standalone
// pages and modals — kept in one place so an updated Calendly link or a
// re-hosted legal PDF only needs to change here, not at every call site.

export const CALENDLY_DEMO_URL =
  'https://calendly.com/astepanyan-1/15-minute-intro-call';

export const BLOG_URL = 'https://map-ai.co/blog';

export const TERMS_OF_USE_URL =
  'https://cdn.prod.website-files.com/645fc9b1f2ae787ad9542f5d/6679c67c85e0ff12b6427c30_Terms%20of%20Use.docx.pdf';

export const PRIVACY_NOTICE_URL =
  'https://cdn.prod.website-files.com/645fc9b1f2ae787ad9542f5d/6564d9191be9d5bf4b050a2b_Privacy%20Notice.pdf';
